export default [
    {
        path: '/hr/reimbursements',
        name: 'reimbursements',
        props: true,
        component: () => import('@/views/hr/reimbursements/index.vue'),
        meta: {
            pageTitle: 'Reimbursement',
            breadcrumb: [
                {
                text: 'Reimbursement',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/reimbursements/:id',
        name: 'detail-reimbursements',
        props: true,
        component: () => import('@/views/hr/reimbursements/detail.vue'),
        meta: {
            pageTitle: 'Detail Reimbursement',
            breadcrumb: [
                {
                text: 'Reimbursements',
                to: { name: 'reimbursements' },
                },
                {
                text: 'Detail Reimbursement',
                active: true,
                },
            ],
        },
    },
]